export default ({ strapi }) => {
	// destroy phase
};
